import(/* webpackMode: "eager" */ "/app/app/low-ticket/page.tsx");
